// Components
import eodCard from './eod-card.vue'
import eodTextField from './eod-text-field.vue'
import eodTextarea from './eod-textarea.vue'
import eodAutocomplete from './eod-autocomplete.vue'
import eodTaskForm from './eod-task-form.vue'
import eodWorkflow from './eod-workflow.vue'
import eodWorkflowDialog from './eod-workflow-dialog.vue'
import eodWorkflowConfig from './eod-workflow-config.vue'
import eodMeasurement from './eod-measurement.vue'
import eodCell from './eod-cell.vue'
import eodItemTreeview from './eod-item-treeview.vue'
import eodItemTreeviewSelector from './eod-item-treeview-selector.vue'
import eodStorageLibrary from './eod-storage-library.vue'
import eodStorageObject from './eod-storage-object.vue'
import eodStorageObjectsCarousel from './eod-storage-objects-carousel.vue'
import eodItemSelector from './eod-item-selector.vue'
import eodDateTimePicker from './eod-datetime-picker.vue'
import eodListItemAutocomplete from './eod-list-item-autocomplete.vue'
import eodListItemSelect from './eod-list-item-select.vue'
import eodObjectAutocomplete from './eod-object-autocomplete.vue'
import eodObjectsTreeview from './eod-objects-treeview.vue'
import eodObjectsTreeviewInput from './eod-objects-treeview-input.vue'
import eodObjectsTreeviewDetail from './eod-objects-treeview-detail.vue'
import eodObjectSelector from './eod-object-selector.vue'
import eodSearch from './eod-search.vue'
import eodColorPicker from './eod-color-picker.vue'
import eodErrorsDialog from './eod-errors-dialog.vue'
import eodTranslations from './eod-translations.vue'
import eodContacts from './eod-contacts.vue'
import eodAddContact from './eod-add-contact.vue'
import eodProducts from './eod-products.vue'
import eodProductDetail from './eod-product-detail.vue'
import eodAddProduct from './eod-add-product.vue'
import eodProductTypes from './eod-productTypes.vue'
import eodProductTypeDetail from './eod-product-type-detail.vue'
import eodAddProductType from './eod-add-productType.vue'
import eodMeasurementType from './eod-measurementType.vue'
import eodMeasurementTypeIndicative from './eod-measurementType-indicative.vue'
import eodMeasurementTypeColumns from './eod-measurementType-columns.vue'
import eodUserDetail from './eod-user-detail.vue'
import eodUserAddress from './eod-user-address.vue'
import eodUserSelector from './eod-user-selector.vue'
import eodDashboard from './eod-dashboard.vue'
import eodAddTimetracking from './eod-add-timetracking.vue'
import eodTimetrackings from './eod-timetrackings.vue'
import eodComments from './eod-comments.vue'
import eodIconPicker from './eod-icon-picker.vue'
import eodReportEditor from './eod-report-editor.vue'
import eodFormEditor from './eod-form-editor.vue'
import eodWorkflowEditor from './eod-workflow-editor.vue'
import eodListItems from './eod-list-items.vue'
import eodQueryFixedFilters from './eod-query-fixed-filters.vue'
import eodExportDialog from './eod-export-dialog.vue'
import eodExportDetail from './eod-export-detail.vue'
import eodLocations from './eod-locations.vue'
import eodLocationsInfo from './eod-locations-info.vue'
import eodLocationForm from './eod-location-form.vue'
import eodLocationsMap from './eod-locations-map.vue'
import eodContactsInfo from './eod-contacts-info.vue'
import eodObjectsTable from './eod-objects-table.vue'
import eodTags from './eod-tags.vue'
import eodItemDialog from './eod-item-dialog.vue'
import eodImportDialog from './eod-import-dialog.vue'
import eodProjectDetail from './eod-project-detail.vue'
import eodProjectInfo from './eod-project-info.vue'
import eodProjectGeneral from './eod-project-general.vue'
import eodServiceInfo from './eod-service-info.vue'
import eodServiceDetail from './eod-service-detail.vue'
import eodCompanyInfo from './eod-company-info.vue'
import eodStatusCodeAutocomplete from './eod-statuscode-autocomplete.vue'
import eodScheduler from './eod-scheduler.vue'
import eodSchedulerSidebar from './eod-scheduler-sidebar.vue'
import eodRoutes from './eod-routes.vue'
import eodRoutesSidebar from './eod-routes-sidebar.vue'
import eodRoutesScheduler from './eod-routes-scheduler.vue'
import eodDeleteDialog from './eod-delete-dialog.vue'
import eodTimeSelector from './eod-time-selector.vue'
import eodExportBackupDialog from './eod-export-backup-dialog.vue'
import eodTreeview from './eod-treeview.vue'
import eodTreeviewInput from './eod-treeview-input.vue'
import eodDepotDetail from './eod-depot-detail.vue'
import eodDialog from './eod-dialog.vue'
import eodBtn from './eod-btn.vue'
import eodLoader from './eod-loader.vue'
import eodObjectAvailability from './eod-object-availability.vue'
import eodAvailabilities from './eod-availabilities.vue'
import eodUserJobTypesConfig from './eod-job-types-config.vue'
import eodCompanyDetail from './eod-company-detail.vue'
import eodAlarmDetail from './eod-alarm-detail.vue'
import eodAlarmList from './eod-alarm-list.vue'
import eodUserNotifications from './eod-user-notifications.vue'
import eodEventsDrawer from './eod-events-drawer'
import eodEventsDrawerCollapse from './eod-events-drawer-collapse'
import eodEventsSidebar from './eod-events-sidebar'
import eodEventsTable from './eod-events-table'
import eodEventsDrawerTable from './eod-events-drawer-table'
import eodEventsTableCompact from './eod-events-table-compact'
import eodEvent from './eod-event'
import eodEventDialog from './eod-event-dialog'
import eodLogs from './eod-logs'
import eodRte from './eod-rte'
import eodWorkflowMailConfig from './eod-workflow-mail-config'
import eodShareDialog from './eod-share-dialog'
import eodProjectAccessDialog from './eod-project-access-dialog'
import eodButtonCopy from './eod-button-copy'
import eodMenu from './eod-menu'
import eodAcls from './eod-acls'
import eodFilterAutocomplete from './eod-filter-autocomplete'
import eodExpansionPanels from './eod-expansion-panels.vue'
import eodTranslated from './eod-translated.vue'
import eodToolDetail from './eod-tool-detail.vue'
import eodToolTypeDetail from './eod-tool-type-detail.vue'
import eodArticleDetail from './eod-article-detail.vue'
import eodArticleTypeDetail from './eod-article-type-detail.vue'
import eodArticleStockMovements from './eod-article-stock-movements.vue'
import eodProducttypesProductsSelector from './eod-producttypes-products-selector.vue'
import eodQueryBuilder from './eod-query-builder.vue'
import eodIcon from './eod-icon.vue'
import eodIntegrationIds from './eod-integration-ids.vue'
import eodCustomFields from './eod-custom-fields.vue'
import eodCustomFieldsItem from './eod-custom-fields-item.vue'
import eodActionDialog from './eod-action-dialog.vue'
import eodChecklist from './eod-checklist.vue'
import eodReportTemplateSelector from './eod-report-template-selector.vue'
import eodProductHistory from './eod-product-history.vue'
import eodNotificationsMenu from './eod-notifications-menu.vue'
import eodCheckbox from './eod-checkbox.vue'
import eodGroups from './eod-groups.vue';
import eodListFields from './eod-list-fields.vue';

// Graph
import eodGraphTable2 from './graphs2/eod-graph-table.vue'
import eodEvolutionGraph from './eod-evolution-graph.vue'
import eodGraphFilters from './graphs/eod-graph-filters.vue'

// Columns
import eodColumnActions from './columns/eod-column-actions.vue';
import eodColumnProject from './columns/eod-column-project.vue';
import eodColumnCompany from './columns/eod-column-company.vue';
import eodColumnStatusCode from './columns/eod-column-status-code.vue';

const globalComponents = [
    eodWorkflow,
    eodCard,
    eodTextField,
    eodTextarea,
    eodAutocomplete,
    eodExpansionPanels,
    eodDialog,
    eodBtn,
    eodCheckbox,
    eodTaskForm,
    eodTranslated,
    eodIcon,
    eodActionDialog,
    eodDeleteDialog
]

export {
    globalComponents,
    eodLoader,
    eodIcon,
    eodRte,
    eodWorkflowMailConfig,
    eodExportBackupDialog,
    eodUserJobTypesConfig,
    eodRoutes,
    eodAlarmDetail,
    eodAlarmList,
    eodAcls,
    eodRoutesSidebar,
    eodRoutesScheduler,
    eodTimeSelector,
    eodDeleteDialog,
    eodStatusCodeAutocomplete,
    eodProjectInfo,
    eodProjectGeneral,
    eodCompanyInfo,
    eodServiceInfo,
    eodServiceDetail,
    eodImportDialog,
    eodListItems,
    eodFormEditor,
    eodWorkflowEditor,
    eodContactsInfo,
    eodLocationsInfo,
    eodLocationsMap,
    eodLocations,
    eodLocationForm,
    eodExportDialog,
    eodExportDetail,
    eodObjectsTable,
    eodObjectsTreeview,
    eodObjectsTreeviewInput,
    eodObjectsTreeviewDetail,
    eodFilterAutocomplete,
    eodTags,
    eodMenu,
    eodItemDialog,
    eodScheduler,
    eodSchedulerSidebar,
    eodCompanyDetail,
    eodProjectDetail,
    eodEventsDrawer,
    eodEventDialog,
    eodEventsDrawerCollapse,
    eodEventsTable,
    eodEventsDrawerTable,
    eodEventsTableCompact,
    eodEventsSidebar,
    eodEvent,
    eodLogs,
    eodIconPicker,
    eodReportEditor,
    eodComments,
    eodTimetrackings,
    eodAddTimetracking,
    eodDashboard,
    eodGraphTable2,
    eodGraphFilters,
    eodEvolutionGraph,
    eodColorPicker,
    eodSearch,
    eodItemSelector,
    eodListItemAutocomplete,
    eodListItemSelect,
    eodObjectAutocomplete,
    eodObjectSelector,
    eodDateTimePicker,
    eodStorageLibrary,
    eodStorageObject,
    eodStorageObjectsCarousel,
    eodTaskForm,
    eodWorkflow,
    eodWorkflowDialog,
    eodWorkflowConfig,
    eodMeasurement,
    eodShareDialog,
    eodProjectAccessDialog,
    eodButtonCopy,
    eodCell,
    eodTreeview,
    eodTreeviewInput,
    eodItemTreeview,
    eodItemTreeviewSelector,
    eodErrorsDialog,
    eodTranslations,
    eodContacts,
    eodAddContact,
    eodProducts,
    eodProductDetail,
    eodProductTypeDetail,
    eodToolDetail,
    eodToolTypeDetail,
    eodArticleDetail,
    eodArticleTypeDetail,
    eodArticleStockMovements,
    eodAddProduct,
    eodProductTypes,
    eodAddProductType,
    eodMeasurementType,
    eodMeasurementTypeIndicative,
    eodMeasurementTypeColumns,
    eodUserDetail,
    eodUserNotifications,
    eodUserAddress,
    eodUserSelector,
    eodColumnActions,
    eodColumnProject,
    eodColumnCompany,
    eodColumnStatusCode,
    eodDepotDetail,
    eodObjectAvailability,
    eodAvailabilities,
    eodQueryFixedFilters,
    eodProducttypesProductsSelector,
    eodDialog,
    eodBtn,
    eodQueryBuilder,
    eodIntegrationIds,
    eodCustomFields,
    eodCustomFieldsItem,
    eodActionDialog,
    eodChecklist,
    eodReportTemplateSelector,
    eodProductHistory,
    eodNotificationsMenu,
    eodGroups,
    eodListFields,
}